import React, {useEffect, useState} from "react";
import useToastNotify from "../../../hook/useToastNotify";
import {useLocation} from "react-router-dom";
import {IPagesProps} from "../../../contracts/pages";
import httpClient from "../../../services/httpClient";
import {categoriesInVideoProductApi} from "../../../constans/apiUrls";
import TableTr from "../../Elements/Table/TableTr";
import TableTd from "../../Elements/Table/TableTd";
import TableTdContent from "../../Elements/Table/TableTdContent";
import Badge from "../../Elements/Badge";
import {badgeType} from "../../../constans/enumTypes";
import MenuDrop from "../../Elements/MenuDrop";
import MenuDropItem from "../../Elements/MenuDrop/MenuDropItem";
import {FiEdit} from "react-icons/fi";
import {MdOutlineLoop} from "react-icons/md";
import Table from "../../Elements/Table";
import TableEmpty from "../../Elements/Table/TableEmpty";
import useQuery from "../../../hook/useQuery";
import {generateFileTypeTitle, generateVideoLinkTypeTitle, isNotEmpty} from "../../../helpers/functions";
import {IFileCategoryData} from "../../../contracts/data/file_category";
import PageHeader from "../../Elements/PageHeader";
import {IRouterListToData} from "../../../contracts/data/router";
import {BsTrash3} from "react-icons/bs";
import MyModal from "../../Elements/MyModal";
import AddFileToCategoryForm from "../../../forms/dashboard/video_product/AddFileToCategoryForm";

const FilesListInCategoryForVideoProducts:React.FC<IPagesProps> = () => {
    const {toastNotify} = useToastNotify();
    const location = useLocation<IRouterListToData>()
    const queryParams = useQuery()
    const [data, setData] = useState<Array<IFileCategoryData>>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [showModal, setShowModal] = useState<boolean>(false)
    const [reload, setReload] = useState<boolean>(false);

    const titleHeadTable: Array<string> = ['#', 'عنوان', 'نوع لینک', 'نوع فایل', 'تاریخ انتشار' , 'وضعیت انتشار', 'وضعیت', 'عملیات']

    const fetchItemsData = async (search: string | null | undefined = "") => {
        await httpClient().get(`${categoriesInVideoProductApi.files_list}/${queryParams.get('id')}`)
            .then(response => {
                if(response.status === 200){
                    setData(response.data)
                }
            })
            .catch(error => toastNotify('error', 'مشکلی در دریافت لیست آیتم ها وجود دارد'))
            .finally(() => setLoading(false))
    }

    const handleChangeStatusItem = async (id: number, index: number) => {
        await httpClient().put(categoriesInVideoProductApi.files_status, {file_category: id})
            .then(response => {
                if(response.status === 200){
                    data[index].is_active = !data[index].is_active
                    setReload(true)
                }
            })
            .catch(error => {console.log(error)})
    }

    const handleRemoveItemFromList = async (id: number, index: number) => {
        await httpClient().delete(categoriesInVideoProductApi.files_delete, {params: {file_category: id}})
            .then(response => {
                if (response.status === 200) {
                    let items:Array<IFileCategoryData> = data.filter(value => value.id !== id)
                    setData(items)
                    toastNotify(response?.data?.status, response?.data?.message)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    useEffect(() => {
        fetchItemsData()
    }, [])

    useEffect(() => {
        if (reload) {
            setReload(false)
        }
    }, [reload])

    const itemsTableRows = data.map((item, index) =>
        <TableTr key={`table-row${index}`}>
            <TableTd><TableTdContent content={`${index + 1}`}/></TableTd>
            <TableTd><TableTdContent content={item?.file_info?.title} /></TableTd>
            <TableTd><TableTdContent content={generateVideoLinkTypeTitle(item?.file_info?.link_type)} /></TableTd>
            <TableTd><TableTdContent content={generateFileTypeTitle(item?.file_info?.type)} /></TableTd>
            <TableTd><TableTdContent content={item?.file_info?.release_date_jalali_str} /></TableTd>
            <TableTd>
                <Badge title={item?.file_info?.is_release ? "منتشر شده" : "منتشر نشده"}
                       typeBadge={item?.file_info?.is_release ? badgeType.success : badgeType.error}/>
            </TableTd>
            <TableTd>
                <Badge title={item?.is_active ? "فعال" : "غیرفعال"}
                       typeBadge={item?.is_active ? badgeType.success : badgeType.error}/>
            </TableTd>
            <TableTd>
                <MenuDrop>
                    <MenuDropItem title={"ویرایش"} icon={<FiEdit/>} isLinkBtn urlLinkProps={{
                        pathname: '/dashboard/files-categories/edit',
                        search: `?id=${item?.id}&categoryId=${queryParams.get('id')}&name=${queryParams.get('name')}`,
                        state: {page: location.pathname, page_num: 1}
                    }}/>
                    <MenuDropItem title={"حذف فایل"} icon={<BsTrash3/>}
                                  handleOnSubmit={() => handleRemoveItemFromList(item?.id, index)}/>
                    <MenuDropItem title={"تغییر وضعیت"} icon={<MdOutlineLoop/>}
                                  handleOnSubmit={() => handleChangeStatusItem(item?.id, index)}/>
                </MenuDrop>
            </TableTd>
        </TableTr>
    )

    return(
        <React.Fragment>
            <PageHeader
                title={`لیست فایل ها در دسته بندی "${isNotEmpty(queryParams.get('name')) ? queryParams.get('name') : ''}"`}
                isBackBtn urlBackBtn={`${(typeof location?.state?.page !== 'undefined' && location?.state?.page) ? location?.state?.page : "/dashboard/categories-video-products/list"}?page_num=${(typeof location?.state?.page_num !== 'undefined' && location?.state?.page_num) ? location?.state?.page_num : "1"}`}
                isFirstBtn={true} firstBtnTitle={'افزودن فایل به دسته بندی'} handlerFirstBtn={() => {
                setShowModal(true)
            }}/>
            <MyModal title={'افزودن فایل به دسته بندی'} isOpen={showModal} handlerSecondaryButton={() => {
                setShowModal(false)
            }} btnSecondaryTxt={"بیخیال!"}>
                <AddFileToCategoryForm formType={'create'} categoryId={parseInt(queryParams.get('id')!)}
                                               handleChange={(newItem: IFileCategoryData) => {
                                                   setData([...data, newItem])
                                                   setShowModal(false)
                                               }}/>
            </MyModal>
            <Table isLoading={loading} titlesTable={titleHeadTable} isSearch={false}>
                {itemsTableRows.length > 0 ? itemsTableRows :
                    <TableEmpty colSpan={titleHeadTable.length} message={"فایلی یافت نشد"}/>}
            </Table>
        </React.Fragment>
    )
}

export default FilesListInCategoryForVideoProducts